import { ViewHook } from "phoenix_live_view";

/**
 * Re-dispatches phoenix events to the parent element.
 *
 * This is useful when we've mounted components outside the liveview lifecycle and we
 * want to update/destroy them etc inline with the liveview lifecycle.
 */
class RedispatchEvents extends ViewHook {
  mounted() {
    this.el.dispatchEvent(new CustomEvent("mounted"));
  }

  updated() {
    this.el.dispatchEvent(new CustomEvent("updated"));
  }

  destroyed() {
    this.el.dispatchEvent(new CustomEvent("destroyed"));
  }
}

export default RedispatchEvents;
